<div *ngIf="(readyToDisplay$ | async)">
    <div class="mb:pb-24">
        <div *ngIf="navigationMenu && navigationMenu?.length > 0">
            <vsf-section-nav-menu
                [isMobile]="isMobile"
                [showTopNav]="showTopNav"
                [isHeaderFloating]="isHeaderFloating"
                [withHeaderMessage]="withHeaderMessage"
                [navigationMenu]="navigationMenu"
                (navItemClicked)="scrollToSection($event)"
            ></vsf-section-nav-menu>
        </div>
        <ng-container>
            <h1 *ngIf="h1CustomText && h1StyleMode !== 'sr-only'"
                [innerHTML]="h1CustomText | safeHtml"
                [ngStyle]="h1CustomStyles"
                class="page-h1-heading max-w-6xl mx-auto px-4 py-2 text-3xl font-bold"></h1>
            <h1 *ngIf="h1CustomText && h1StyleMode === 'sr-only'"
                class="sr-only">{{ h1CustomText }}</h1>
            <div *ngIf="pageComponents?.length > 0">
                <div *ngFor="let component of pageComponents; let i = index" [ngStyle]="layoutOrder[i].styles" [id]="component.sectionId">
                    <vsf-page-component
                        [pageComponent]="component"
                        [linePadding]="layoutOrder[i].linePadding"
                        [horizontalPadding]="layoutOrder[i].horizontalPadding"
                        [sectionRoundedClass]="layoutOrder[i].roundedClass"
                        [isMobile]="isMobile"
                        [sellerChannelId]="storeInfo?.sellerChannel?.id"
                        [pdpAssetsArrowType]="pdpAssetsArrowType"
                        [pageFullWidth]="layoutOrder[i].pageFullWidth ?? false"
                        [sectionMaxHeight]="layoutOrder[i].sectionMaxHeight || ''"
                        [isPageHeading]="i === h1PageHeadingIndex"
                        [h1StyleMode]="h1StyleMode">
                    </vsf-page-component>
                </div>
            </div>
        </ng-container>
    </div>
</div>
